import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { UnsubscribeComponent } from '../../generals/Components';
import { generateDeleteText } from '../../helpers/helper';

@Component({
  selector: 'app-categorydelete',
  templateUrl: './categorydelete.component.html',
  styleUrls: ['./categorydelete.component.scss']
})
export class CategorydeleteComponent extends UnsubscribeComponent implements AfterViewInit {

  @ViewChild('input') input: ElementRef<HTMLInputElement>;

  deleteText: string = generateDeleteText();
  deleteInput: string|null = null;
  precheckWarning: string|null = null;

  loading = false;

  constructor(
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private apiService: ApiService
  ) {
    super();
  }

  delete(): void {
    this.loading = true;
    this.apiService.deleteCategory(this.config.data.categoryId).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.close(true);
    }).add(() => {
      this.loading = false;
    });
  }

  close(result: boolean = false): void {
    this.ref.close(result);
  }

  ngAfterViewInit(): void {
    this.input.nativeElement.focus();
  }
}
